import React from 'react';
import { connect } from 'react-redux';
import { CreateSurveyProps } from '../common/CreateSurveyProps';
import { ApplicationState } from '../store';
import * as CreateSurveyStore from '../store/CreateSurvey';
import { DownloadCsv, GetDateString } from "../common/helperFunctions";
import produce from 'immer';
import { LinkModel, SurveyLinkModel } from '../models/searchSurvey.model';
import Header from "../components/header";
import { Link } from 'react-router-dom';
import authHeader from '../services/auth-header';

export interface LinkGeneratorState {
    isLoading: number;
    numberOfLinks: number;
    isPublic: boolean,
    survey: SurveyLinkModel;
    previousSurvey: SurveyLinkModel;
    newLinks: LinkModel[];
    links: LinkModel[][];
}
 
class LinkGenerator extends React.Component<CreateSurveyProps, LinkGeneratorState> {
    linksx : LinkModel[][] = [];
    baseurl = '';

    state = {
        isLoading: -1,
        numberOfLinks: 0,
        isPublic: false,
        survey: new SurveyLinkModel(),
        previousSurvey: new SurveyLinkModel(),
        newLinks: [],
        links: this.linksx
    }

    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.baseurl = window.location.origin + "/campaign/" ;

        this.baseurl = this.baseurl.toLowerCase().replace("admin","");
        const surveyId = this.props.match.params.surveyId || 0;

        fetch(`/Admin/Link/${surveyId}`, authHeader("GET", '', ''))
        .then(response => response.json() as Promise<SurveyLinkModel>
        )
        .then(data => {
            this.setDataInState(data);
        })
        .catch(error => {
            //console.log('error', error);
            this.setState(produce(this.state, draftState => {
                draftState.isLoading = 0;
            }));
        });
    }

    private handleGenerateLink = () => {
        if (this.state.isLoading <= 0) {
            this.setState(produce(this.state, draftState => {
                draftState.isLoading = 1;
            }));

            fetch(`/Admin/GenerateUniqueLinks/${this.state.survey.surveyId}/${this.state.numberOfLinks}/${this.state.isPublic}`, authHeader("GET", '', ''))
            .then(response => response.json() as Promise<SurveyLinkModel>
            )
            .then(data => {
                this.setDataInState(data);
            })
            .catch(error => {
                this.setState(produce(this.state, draftState => {
                    draftState.isLoading = 0;
                }));
            });
        }
    }

    private handleOnCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState(produce(this.state, draftState => {
            draftState.isPublic = e.target.checked;
        }));
    }

    private handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState(produce(this.state, draftState => {
            draftState.numberOfLinks = +e.target.value;
        }));
    }
    
    private setDataInState(data: SurveyLinkModel){
        const linkArray = this.splitLinkArray(data.linkList);

        this.setState(produce(this.state, draftState => {
            draftState.survey = data;
            draftState.previousSurvey = data;
            draftState.isLoading = 0;
            draftState.links = linkArray;
        }));
    }

    private splitLinkArray(links: LinkModel[]) : LinkModel[][] {
        let result: LinkModel[][] = [];

        if (links && links.length > 0) {
            let x = 0;
            for (var i = 0; i < links.length; i++) {
                
                if ( (i === links.length - 1) || links[i].createdOn !== links[i + 1].createdOn) {
                    result.push(links.slice(x, i+1));

                    x = i+1;
                }
            }
        }

        return result;

    }

    private downloadCsv(links: LinkModel[][]) {

        if (links && links.length > 0) {
            let csv = '';

            links.forEach(lnkArr => {
                
                lnkArr.forEach(e => {
                       
                    csv += '"';
                    csv += this.baseurl;
                    csv += e.link;
                    csv += '"\n';
                });
                    
            });

            DownloadCsv(csv, 'links');
        }
    
    }


    render() { 

        if (this.state.survey !== null && 
        this.state.survey !== undefined && 
        this.state.survey && 
        this.state.survey.surveyId !== undefined) {

            return (
                <>
                <Header props={this.props}></Header>
                <div className="row">
                    <div className="col-sm-12 col-md-6">
                        <h3 className="mb-4">Campaign Information</h3>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="d-flex flex-row-reverse">
                            <Link className="btn btn-warning" to={`/search`}>Campaign List</Link>
                        </div>
                    </div>
                </div>
                { this.renderSurveyInfo() }
                
                <div className="row g-3">
                    <div className="col">
                        <input type="text" placeholder="Num of Links to be Generated" className="form-control" onChange={this.handleOnChange} />
                    </div>
                    <div className="col">
                        <div className="mt-2 form-check form-switch">
                            <input className="form-check-input" type="checkbox" id="ispublic"  onChange={this.handleOnCheckChange}></input>
                            <label className="form-check-label">Public Link</label>
                        </div>
                    </div>
                    <div className="col d-flex align-items-end">
                        <button className="btn btn-success" onClick={this.handleGenerateLink}>Generate Link(s)</button>
                    </div>
                    <div className="col">
                        <div className="d-flex flex-row-reverse">
                            <button className="btn btn-success" onClick={() => {this.downloadCsv(this.state.links)}}>Download All Links</button>
                        </div>
                    </div>
                </div>
                <p className='text-danger'>Campaign links generated in Draft state, cannot be use when published</p>
                <h3 className="mt-4">Campaign links</h3>

                { this.renderSurveyLinkArray(this.state.links) }
                </>
            )
        } else {

            return ( <Header props={this.props}></Header> );
        }
    }

    private renderSurveyInfo() {
        return (
           <table className="table table-striped">
                <tbody>
                <tr><th>Id:</th><td>{this.state.survey.surveyId}</td></tr>
                <tr><th>Name:</th><td>{this.props.survey.name || this.props.survey.title || this.props.survey.titleEn || ''}</td></tr>
                <tr><th>Status:</th><td>{this.state.survey.status}</td></tr>
                </tbody>
            </table>
        );
    }

    private renderSurveyLinkArray(links: LinkModel[][]) {

        const items: any = [];

        links.forEach(e => {
                items.push( this.renderSurveyLink(e) );
            });

        return (
            <>
                {items}
            </>
        );
    }

    private renderSurveyLink(links: LinkModel[]) {

        if (links && links.length > 0) {
            return (
                <React.Fragment key={links[0].id + 'rr'}>
                <div className="row g-3 mt-2 mb-1">
                    <div className="col-sm-6 mb-0">
                        <h5>Links Created On: <span className="fw-bold">{GetDateString(links[0].createdOn, true)}</span></h5>
                    </div>
                    <div className="col-sm-6 mb-0">
                        <div className="d-flex flex-row-reverse">
                            <button className="btn btn-success mb-0" onClick={() => {this.downloadCsv([links])}}>Download CSV</button>
                        </div>
                    </div>
                </div>

                <table className="table table-striped">
                    <tbody>
                    <tr>
                        <th>S.No.</th>
                        {<th>Type</th>}
                        {/*<th>Status</th>*/}
                        <th>Link</th>
                    </tr>
                    { links.map((l, index) => 
                            <tr key={ l.id } >
                                <td>{ index + 1 }</td>
                                <td>{ l.isPublic ? 'Public' : 'Unique' }</td>
                                {/*<td>{ l.status }</td>*/}
                                <td>{ this.baseurl }{ l.link }</td>
                            </tr>)}
                    </tbody>
                </table>
                </React.Fragment>
            );
        }

        return '';

    }
}
 
export default LinkGenerator;
